export const getWebVersion = () => {
  const { version } = require('../web-version-info.json')
  return version
}
